import { render, staticRenderFns } from "./client-code-switch-maintenance.vue?vue&type=template&id=27bf3c60&"
import script from "./client-code-switch-maintenance.vue?vue&type=script&lang=js&"
export * from "./client-code-switch-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports